import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { webhookSubscriptionKeys } from "./query-keys";
import type {
  PaginatedWebhookSubscriptionsResponse,
  UseWebhookSubscriptionsParams,
} from "./types";

import { instance } from "@/lib/axios/instance";

export function useWebhookSubscriptions(
  params: UseWebhookSubscriptionsParams
) {
  return useQuery<PaginatedWebhookSubscriptionsResponse, AxiosError>({
    queryKey: webhookSubscriptionKeys.list(params),
    queryFn: () =>
      instance
        .get<PaginatedWebhookSubscriptionsResponse>(
          "/api/v2/webhook-subscriptions",
          {
            params: {
              integrationId: params.integrationId,
              page: params.page ?? 1,
              pageSize: params.pageSize ?? 10,
              orderBy: params.orderBy,
              descending: params.descending,
            },
          }
        )
        .then((res) => res.data),
    enabled: !!params.integrationId,
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  });
}
